/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FreelancerWorkforceDetailsV2Resource } from './';
import {
    FreelancerWorkforceDetailsV2ResourceFromJSON,
    FreelancerWorkforceDetailsV2ResourceFromJSONTyped,
    FreelancerWorkforceDetailsV2ResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface FreelancersWorkforceListV2Resource
 */
export interface FreelancersWorkforceListV2Resource {
    /**
     * 
     * @type {Array<FreelancerWorkforceDetailsV2Resource>}
     * @memberof FreelancersWorkforceListV2Resource
     */
    items: Array<FreelancerWorkforceDetailsV2Resource>;
    /**
     * 
     * @type {number}
     * @memberof FreelancersWorkforceListV2Resource
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof FreelancersWorkforceListV2Resource
     */
    pageSize: number;
    /**
     * 
     * @type {number}
     * @memberof FreelancersWorkforceListV2Resource
     */
    totalElements: number;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancersWorkforceListV2Resource
     */
    downloadEnabled: boolean;
}

/**
 * Check if a given object implements the FreelancersWorkforceListV2Resource interface.
 */
export function instanceOfFreelancersWorkforceListV2Resource(value: object): value is FreelancersWorkforceListV2Resource {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('pageSize' in value) || value['pageSize'] === undefined) return false;
    if (!('totalElements' in value) || value['totalElements'] === undefined) return false;
    if (!('downloadEnabled' in value) || value['downloadEnabled'] === undefined) return false;
    return true;
}

export function FreelancersWorkforceListV2ResourceFromJSON(json: any): FreelancersWorkforceListV2Resource {
    return FreelancersWorkforceListV2ResourceFromJSONTyped(json, false);
}

export function FreelancersWorkforceListV2ResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancersWorkforceListV2Resource {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(FreelancerWorkforceDetailsV2ResourceFromJSON)),
        'page': json['page'],
        'pageSize': json['pageSize'],
        'totalElements': json['totalElements'],
        'downloadEnabled': json['downloadEnabled'],
    };
}

export function FreelancersWorkforceListV2ResourceToJSON(value?: FreelancersWorkforceListV2Resource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'items': ((value['items'] as Array<any>).map((v) => FreelancerWorkforceDetailsV2ResourceToJSON(v))),
        'page': value['page'],
        'pageSize': value['pageSize'],
        'totalElements': value['totalElements'],
        'downloadEnabled': value['downloadEnabled'],
    };
}

